// Generated from src/assets/Check.svg
import React, { PureComponent } from "react";

interface ISVGUserPasswordProps {
  /**
   * additional classname
   */
  // prettier-ignore
  className?: string;
  /**
   * size of the svg icon
   */
  // prettier-ignore
  size?: string | number;
  /**
   * color of the svg icon
   */
  // prettier-ignore
  fill?: string;
  /**
   * onClick event
   */
  // prettier-ignore
  onClick?: React.MouseEventHandler<SVGSVGElement>;
}

const style = {
  cursor: "pointer",
  width: "35px"
};

export default class SVGUserPasswordIcon extends PureComponent<
  ISVGUserPasswordProps,
  {}
> {
  render() {
    const props = this.props;
    const { size, fill } = props;
    return (
      <svg
        {...props}
        preserveAspectRatio="xMidYMid meet"
        fontSize={size || 35}
        fill={fill || "currentColor"}
        style={style}
        viewBox="0 0 35 35"
        enableBackground="new 0 0 35 35"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          fill="#FFFFFF"
          d="M31.598,15.792c-0.574-2.363-2.337-4.398-5.241-4.391
	c0-0.011,0-0.023,0-0.035c-0.012,0-0.023,0-0.036,0c0-1.008,0.101-2.218-0.106-3.081c-0.238-0.993-0.375-1.948-0.744-2.797
	c-1.343-3.105-3.929-5.256-8.462-5.17c-0.116,0.073-0.331,0-0.496,0.036c-0.377,0.059-0.756,0.118-1.133,0.177
	c-0.994,0.276-1.91,0.604-2.691,1.097c-1.68,1.06-2.826,2.791-3.505,4.852C8.966,7.137,8.921,7.857,8.758,8.568
	C8.7,8.826,8.807,9.181,8.688,9.383c0,0.472,0,0.944,0,1.417c0,0.172,0.035,0.456-0.036,0.566c-0.171,0.106-0.442,0.019-0.673,0.071
	c-0.275,0.062-0.573,0.088-0.85,0.177c-1.234,0.399-2.304,1.193-2.939,2.196c-0.95,1.5-0.85,3.159-0.85,5.594
	c0,2.349,0,4.698,0,7.047c0,1.357-0.173,3.043,0.142,4.178c0.212,0.765,0.572,1.449,0.992,2.019
	c0.654,0.883,1.721,1.525,2.903,1.876c0.59,0.175,1.315,0.142,2.054,0.142c0.944,0,1.888,0,2.833,0c3.092,0,6.186,0,9.278,0
	c1.239,0,2.479,0,3.717,0c0.676,0,1.439,0.074,2.019-0.07c1.833-0.458,3.083-1.401,3.859-2.904c0.548-1.06,0.531-2.539,0.531-4.178
	c0-1.133,0-2.267,0-3.399c0-1.83,0-3.659,0-5.489C31.668,17.707,31.792,16.599,31.598,15.792z M13.609,5.984
	c0.21-0.314,0.445-0.664,0.743-0.885c0.496-0.369,1.07-0.65,1.735-0.85c0.954-0.286,2.424-0.151,3.222,0.143
	c2.616,0.96,3.308,3.378,3.258,7.01c-3.375,0-6.752,0-10.127,0C12.443,8.984,12.654,7.416,13.609,5.984z M28.587,18.271
	c0,1.959,0,3.918,0,5.877c0,1.322,0,2.644,0,3.966c0,1.176,0.038,1.948-0.46,2.62c-0.683,0.922-1.74,0.85-3.329,0.85
	c-1.758,0-3.517,0-5.275,0c-2.821,0-5.642,0-8.463,0c-1.448,0-2.949,0.162-3.789-0.46c-0.99-0.732-0.85-1.987-0.85-3.683
	c0-2.667,0-5.335,0-8.002c0-0.992-0.154-2.87,0.142-3.576c0.205-0.491,0.685-0.992,1.168-1.204c0.2-0.059,0.401-0.117,0.602-0.177
	c4.732,0,9.467,0,14.199,0c1.874,0,4.47-0.31,5.418,0.637C28.669,15.838,28.587,16.844,28.587,18.271z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          fill="#FFFFFF"
          d="M17.15,19.263c0.307,0.012,0.613,0.024,0.92,0.035
	c1.165,0.312,2.488,1.734,1.806,3.364c-0.123,0.293-0.364,0.732-0.602,0.921c-0.083,0.065-0.463,0.287-0.496,0.354
	c0,0.979,0,1.96,0,2.939c-0.038,0.062-0.007,0.151-0.035,0.248c-0.076,0.259-0.262,0.565-0.46,0.708
	c-0.109,0.078-0.3,0.174-0.426,0.212c-0.318,0.097-0.674,0.002-0.885-0.106c-0.274-0.141-0.517-0.316-0.638-0.602
	c-0.251-0.596-0.118-2.547-0.106-3.399c-1.193-0.699-1.686-2.438-0.708-3.753c0.233-0.313,0.683-0.621,1.063-0.779
	C16.755,19.333,16.998,19.359,17.15,19.263z"
        />
      </svg>
    );
  }
}
